export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12794.e3ec8a36.jpg";